module.exports = __webpack_public_path__ + "img/Onboarding_Asset_2.8d54f6f2.svg";